import { useState, useEffect } from 'react';
import Button from '../Button/Button';
import './LoadSavedGames.css';
import { useWarpTransition } from '../WarpTransition/WarpTransitionProvider';

const LoadSavedGames = ({ setPlayerNamesState }) => {
  const [savedGames, setSavedGames] = useState([]);
  const { startTransition } = useWarpTransition();

  useEffect(() => {
    const saves = JSON.parse(localStorage.getItem('savedGames')) || [];
    setSavedGames(saves);
  }, []);

  const loadSavedGame = (saveName) => {
    const saveToLoad = savedGames.find((save) => save.name === saveName);
    if (saveToLoad) {
      startTransition({
        to: '/multi/pre-roll',
        label: 'SAVE STATE RESTORED',
        variant: 'portal',
        onNavigate: () => {
          setPlayerNamesState(saveToLoad.data);
          localStorage.setItem('currentSaveName', saveToLoad.name);
        },
      });
    } else {
      alert(`Save "${saveName}" not found.`);
    }
  };

  const deleteSavedGame = (saveName) => {
    if (
      !window.confirm(`Are you sure you want to delete the "${saveName}" game?`)
    )
      return;
    const filtered = savedGames.filter((s) => s.name !== saveName);
    localStorage.setItem('savedGames', JSON.stringify(filtered));
    setSavedGames(filtered);
  };

  if (savedGames.length === 0)
    return <p className="loadSavedGames__empty">No saved games found.</p>;

  return (
    <section
      className="loadSavedGames"
      aria-labelledby="load-saved-games-title"
    >
      <h3 id="load-saved-games-title">Load Saved Games</h3>
      <ul className="loadSavedGames__list">
        {savedGames.map((save) => (
          <li key={save.timestamp} className="loadSavedGames__row">
            <span className="loadSavedGames__name">{save.name}</span>
            <div className="loadSavedGames__actions">
              <Button
                title="Load"
                type="smallSquare loadSavedGame"
                ariaLabel={`Load saved game ${save.name}`}
                handleClick={() => loadSavedGame(save.name)}
              />
              <Button
                type="smallSquare loadSavedGame"
                ariaLabel={`Delete saved game ${save.name}`}
                handleClick={() => deleteSavedGame(save.name)}
              />
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default LoadSavedGames;
